export const homeGuideCollapseKeys = Object.freeze([
  "isShow1",
  "isShow1_1",
  "isShow1_2",
  "isShow1_3",
  "isShow1_4",
  "isShow2",
  "isShow2_1",
  "isShow2_2",
  "isShow2_3",
  "isShow2_4",
  "isShow2_5",
  "isShow2_6",
  "isShow3",
  "isShow3_1",
  "isShow3_2",
  "isShow3_3",
  "isShow3_4",
  "isShow3_5",
  "isShow3_6",
  "isShow4",
  "isShow4_1",
  "isShow4_2",
  "isShow4_3",
  "isShow4_4",
  "isShow4_5",
  "isShow5",
  "isShow6",
  "isShow6_1",
  "isShow6_2",
])

const createTextBlock = (textKey, className = "") => ({ type: "text", textKey, className })

const createImageBlock = (imageKey) => ({ type: "image", imageKey })

const createVideoBlock = (posterImageKey, srcFactory) => ({
  type: "video",
  posterImageKey,
  srcFactory,
})

const createSegment = (textKey, className = "") => ({ textKey, className })

const createLiteralSegment = (text, className = "") => ({ text, className })

const createRichTextBlock = (segments, className = "") => ({ type: "richText", segments, className })

export const homeGuideTitleSchema = Object.freeze([
  {
    id: "part1",
    titleKey: "guide.home.part.1",
    href: "#part1",
    defaultExpanded: true,
    childList: [
      { titleKey: "guide.home.part.1.1", href: "#part_child_1_1" },
      { titleKey: "guide.home.part.1.2", href: "#part_child_1_2" },
      { titleKey: "guide.home.part.1.3", href: "#part_child_1_3" },
      { titleKey: "guide.home.part.1.4", href: "#part_child_1_4" },
    ],
  },
  {
    id: "part2",
    titleKey: "guide.home.part.2",
    href: "#part2",
    defaultExpanded: false,
    childList: [
      { titleKey: "guide.home.part.2.1", href: "#part_child_2_1" },
      { titleKey: "guide.home.part.2.2", href: "#part_child_2_2" },
      { titleKey: "guide.home.part.2.3", href: "#part_child_2_3" },
      { titleKey: "guide.home.part.2.4", href: "#part_child_2_4" },
      { titleKey: "guide.home.part.2.5", href: "#part_child_2_5" },
      { titleKey: "guide.home.part.2.6", href: "#part_child_2_6" },
    ],
  },
  {
    id: "part3",
    titleKey: "guide.home.part.3",
    href: "#part3",
    defaultExpanded: false,
    childList: [
      { titleKey: "guide.home.part.3.1", href: "#part_child_3_1" },
      { titleKey: "guide.home.part.3.2", href: "#part_child_3_2" },
      { titleKey: "guide.home.part.3.3", href: "#part_child_3_3" },
      { titleKey: "guide.home.part.3.4", href: "#part_child_3_4" },
      { titleKey: "guide.home.part.3.5", href: "#part_child_3_5" },
      { titleKey: "guide.home.part.3.6", href: "#part_child_3_6" },
    ],
  },
  {
    id: "part4",
    titleKey: "guide.home.part.4",
    href: "#part4",
    defaultExpanded: false,
    childList: [
      { titleKey: "guide.home.part.4.1", href: "#part_child_4_1" },
      { titleKey: "guide.home.part.4.2", href: "#part_child_4_2" },
      { titleKey: "guide.home.part.4.3", href: "#part_child_4_3" },
      { titleKey: "guide.home.part.4.4", href: "#part_child_4_4" },
      { titleKey: "guide.home.part.4.5", href: "#part_child_4_5" },
    ],
  },
  {
    id: "part6",
    titleKey: "guide.home.part.6",
    href: "#part5",
    defaultExpanded: false,
    childList: [
      { titleKey: "guide.home.part.6.1", href: "#part_child_6_1" },
      { titleKey: "guide.home.part.6.2", href: "#part_child_6_2" },
    ],
  },
  {
    id: "part5",
    titleKey: "guide.home.part.5",
    href: "#part6",
    defaultExpanded: false,
    childList: [],
  },
])

export const createHomeGuideCollapseState = () => Object.fromEntries(
  homeGuideCollapseKeys.map((key) => [key, true]),
)

export const createHomeGuideTitleList = (t) => homeGuideTitleSchema.map((section) => ({
  id: section.id,
  title: t(section.titleKey),
  href: section.href,
  isExpanded: section.defaultExpanded,
  childList: section.childList.map((child) => ({
    title: t(child.titleKey),
    href: child.href,
  })),
}))

export const homeGuidePartSixSections = Object.freeze([
  {
    id: "part_child_6_1",
    titleKey: "guide.home.part.6.1",
    visibleKey: "isShow6_1",
    leadingBreaks: 2,
    trailingBreaks: 1,
    blocks: [
      createTextBlock("guide.txt.part.6.1"),
      createImageBlock("partImag6_1"),
      createImageBlock("partImag6_2"),
      createTextBlock("guide.txt.part.6.2"),
      createImageBlock("partImag6_3"),
      createTextBlock("guide.txt.part.6.3"),
      createImageBlock("partImag6_4"),
    ],
  },
  {
    id: "part_child_6_2",
    titleKey: "guide.home.part.6.2",
    visibleKey: "isShow6_2",
    leadingBreaks: 2,
    trailingBreaks: 1,
    blocks: [
      createTextBlock("guide.txt.part.6.4"),
      createImageBlock("partImag6_5"),
      createTextBlock("guide.txt.part.6.5"),
      createImageBlock("partImag6_6"),
    ],
  },
])

export const homeGuidePartFourIntroBlocks = Object.freeze([
  createRichTextBlock([
    createSegment("g.p3.t.125"),
    createSegment("g.p3.t.126", "w700"),
    createSegment("g.p3.t.127"),
  ]),
  createImageBlock("docImg107"),
])

export const homeGuidePartFourSections = Object.freeze([
  {
    id: "part_child_4_1",
    titleKey: "guide.home.part.4.1",
    visibleKey: "isShow4_1",
    leadingBreaks: 1,
    trailingBreaks: 0,
    blocks: [
      createRichTextBlock([
        createSegment("guide.part.1.txt.29"),
        createSegment("g.p3.t.128", "w700"),
        createSegment("g.p3.t.129"),
      ]),
      createTextBlock("g.p3.t.130"),
      createRichTextBlock([
        createSegment("g.p3.t.131"),
        createSegment("g.p3.t.132", "w700"),
        createSegment("g.p3.t.133"),
        createSegment("g.p3.t.134", "w700"),
        createSegment("g.p3.t.135"),
      ]),
      createImageBlock("docImg108"),
    ],
  },
  {
    id: "part_child_4_2",
    titleKey: "guide.home.part.4.2",
    visibleKey: "isShow4_2",
    leadingBreaks: 1,
    trailingBreaks: 0,
    blocks: [
      createTextBlock("g.p3.t.136"),
      createImageBlock("docImg109"),
      createImageBlock("docImg110"),
      createRichTextBlock([
        createSegment("g.p3.t.137"),
        createSegment("g.p3.t.138", "w700"),
        createSegment("g.p3.t.139"),
        createSegment("g.p3.t.140", "w700"),
        createSegment("g.p3.t.141"),
      ]),
      createImageBlock("docImg111"),
    ],
  },
  {
    id: "part_child_4_3",
    titleKey: "guide.home.part.4.3",
    visibleKey: "isShow4_3",
    leadingBreaks: 1,
    trailingBreaks: 0,
    blocks: [
      createTextBlock("g.p3.t.142"),
      createImageBlock("docImg112"),
      createImageBlock("docImg113"),
      createImageBlock("docImg114"),
    ],
  },
  {
    id: "part_child_4_4",
    titleKey: "guide.home.part.4.4",
    visibleKey: "isShow4_4",
    leadingBreaks: 1,
    trailingBreaks: 0,
    blocks: [
      createTextBlock("g.p3.t.143"),
      createImageBlock("docImg115"),
      createImageBlock("docImg116"),
      createTextBlock("g.p3.t.144"),
      createImageBlock("docImg117"),
    ],
  },
  {
    id: "part_child_4_5",
    titleKey: "guide.home.part.4.5",
    visibleKey: "isShow4_5",
    leadingBreaks: 1,
    trailingBreaks: 1,
    blocks: [
      createRichTextBlock([
        createSegment("g.p3.t.145"),
        createSegment("g.p3.t.146", "w700"),
        createSegment("g.p3.t.147"),
      ]),
      createRichTextBlock([
        createSegment("g.p3.t.148"),
        createSegment("g.p3.t.149", "w700"),
        createSegment("g.p3.t.150"),
      ]),
      createImageBlock("docImg118"),
      createImageBlock("docImg119"),
      createTextBlock("g.p3.t.151"),
      createRichTextBlock([
        createSegment("g.p3.t.152"),
        createSegment("g.p3.t.153", "w700"),
        createSegment("g.p3.t.154"),
      ]),
      createImageBlock("docImg120"),
      createImageBlock("docImg121"),
      createImageBlock("docImg122"),
    ],
  },
])

export const homeGuidePartTwoTailSections = Object.freeze([
  {
    id: "part_child_2_4",
    titleKey: "guide.home.part.2.4",
    visibleKey: "isShow2_4",
    leadingBreaks: 1,
    trailingBreaks: 1,
    blocks: [
      createTextBlock("guide.part.2.txt.85"),
      createImageBlock("docImg58"),
      createRichTextBlock([
        createSegment("g.p2.t.1", "w700"),
        createSegment("g.p2.t.2"),
      ]),
      createRichTextBlock([
        createSegment("g.p2.t.3", "w700"),
        createSegment("g.p2.t.4"),
      ]),
      createRichTextBlock([
        createSegment("g.p2.t.5", "w700"),
        createSegment("g.p2.t.6"),
        createSegment("g.p2.t.7", "w700"),
        createSegment("g.p2.t.8"),
        createSegment("g.p2.t.9", "w700"),
        createSegment("g.p2.t.10"),
      ]),
      createRichTextBlock([
        createSegment("g.p2.t.11", "w700"),
        createSegment("g.p2.t.12"),
      ]),
      createRichTextBlock([
        createSegment("g.p2.t.13", "w700"),
        createSegment("g.p2.t.14"),
        createSegment("g.p2.t.15", "w700"),
        createSegment("g.p2.t.16"),
        createSegment("g.p2.t.17", "w700"),
        createSegment("g.p2.t.18"),
      ]),
      createImageBlock("docImg59"),
      createRichTextBlock([
        createSegment("g.p2.t.19", "w700"),
        createSegment("g.p2.t.20"),
      ]),
      createImageBlock("docImg60"),
      createRichTextBlock([
        createSegment("g.p2.t.21", "w700"),
        createSegment("g.p2.t.22"),
      ]),
      createImageBlock("docImg61"),
    ],
  },
  {
    id: "part_child_2_5",
    titleKey: "guide.home.part.2.5",
    visibleKey: "isShow2_5",
    leadingBreaks: 1,
    trailingBreaks: 1,
    blocks: [
      createRichTextBlock([
        createSegment("g.p2.t.23", "w700"),
        createSegment("g.p2.t.24"),
      ]),
      createImageBlock("docImg62"),
      createImageBlock("docImg63"),
      createRichTextBlock([
        createSegment("g.p2.t.25", "w700"),
        createSegment("g.p2.t.26"),
      ]),
      createImageBlock("docImg64"),
      createImageBlock("docImg65"),
    ],
  },
  {
    id: "part_child_2_6",
    titleKey: "guide.home.part.2.6",
    visibleKey: "isShow2_6",
    leadingBreaks: 1,
    trailingBreaks: 1,
    blocks: [
      createRichTextBlock([
        createSegment("g.p2.t.27"),
        createSegment("g.p2.t.28", "w700"),
        createSegment("g.p2.t.29"),
      ]),
    ],
  },
])

export const homeGuidePartThreeHeadSections = Object.freeze([
  {
    id: "part_child_3_1",
    titleKey: "guide.home.part.3.1",
    visibleKey: "isShow3_1",
    leadingBreaks: 1,
    trailingBreaks: 1,
    blocks: [
      createTextBlock("g.p3.t.2"),
      createTextBlock("g.p3.t.3"),
      createImageBlock("docImg66"),
      createRichTextBlock([
        createSegment("g.p3.t.4"),
        createSegment("g.p3.t.5", "w700"),
        createSegment("g.p3.t.6"),
        createSegment("g.p3.t.7", "w700"),
        createSegment("g.p3.t.8"),
        createSegment("g.p3.t.9", "w700"),
        createSegment("g.p3.t.10"),
      ]),
      createImageBlock("docImg67"),
    ],
  },
  {
    id: "part_child_3_2",
    titleKey: "guide.home.part.3.2",
    visibleKey: "isShow3_2",
    leadingBreaks: 1,
    trailingBreaks: 1,
    blocks: [
      createTextBlock("g.p3.t.11"),
      createRichTextBlock([
        createSegment("g.p3.t.12", "w700"),
        createSegment("g.p3.t.13"),
      ]),
      createImageBlock("docImg68"),
      createRichTextBlock([
        createSegment("g.p3.t.14", "w700"),
        createSegment("g.p3.t.15"),
      ]),
      createImageBlock("docImg69"),
      createRichTextBlock([
        createSegment("g.p3.t.16", "w700"),
        createSegment("g.p3.t.17"),
      ]),
      createImageBlock("docImg70"),
      createRichTextBlock([
        createSegment("g.p3.t.18", "w700"),
        createSegment("g.p3.t.19"),
      ]),
      createImageBlock("docImg71"),
    ],
  },
])

export const homeGuidePartThreeTailSections = Object.freeze([
  {
    id: "part_child_3_3",
    titleKey: "guide.home.part.3.3",
    visibleKey: "isShow3_3",
    leadingBreaks: 1,
    trailingBreaks: 1,
    blocks: [
      createRichTextBlock([
        createSegment("g.p3.t.20"),
        createSegment("g.p3.t.21", "w700 red"),
        createSegment("g.p3.t.22"),
      ]),
      createRichTextBlock([createSegment("g.p3.t.23")], "w700 step"),
      createTextBlock("g.p3.t.24"),
      createImageBlock("docImg72"),
      createImageBlock("docImg73"),
      createRichTextBlock([
        createSegment("guide.part.2.txt.5", "w700 red"),
        createSegment("g.p3.t.25"),
      ]),
      createRichTextBlock([
        createSegment("guide.part.2.txt.10", "w700 red"),
        createSegment("g.p3.t.26"),
        createSegment("g.p3.t.27", "w700"),
        createSegment("g.p3.t.28"),
        createSegment("g.p3.t.29", "w700"),
        createSegment("g.p3.t.30"),
      ]),
      createRichTextBlock([
        createSegment("guide.part.2.txt.16", "w700 red"),
        createSegment("g.p3.t.31"),
      ]),
      createRichTextBlock([
        createSegment("guide.part.2.txt.44", "w700 red"),
        createSegment("g.p3.t.32"),
        createSegment("g.p3.t.33", "w700"),
        createSegment("g.p3.t.34"),
      ]),
      createRichTextBlock([createSegment("g.p3.t.35")], "w700 step"),
      createTextBlock("g.p3.t.36", "w700"),
      createImageBlock("docImg74"),
      createImageBlock("docImg75"),
      createImageBlock("docImg76"),
      createImageBlock("docImg77"),
      createRichTextBlock([
        createSegment("guide.part.2.txt.5", "w700 red"),
        createSegment("g.p3.t.37"),
      ]),
      createRichTextBlock([
        createSegment("guide.part.2.txt.10", "w700 red"),
        createSegment("g.p3.t.38"),
      ]),
      createRichTextBlock([
        createSegment("guide.part.2.txt.16", "w700 red"),
        createSegment("g.p3.t.39"),
      ]),
      createRichTextBlock([
        createSegment("guide.part.2.txt.44", "w700 red"),
        createSegment("g.p3.t.40"),
      ]),
      createRichTextBlock([
        createSegment("g.p3.t.41", "w700 red"),
        createSegment("g.p3.t.42"),
      ]),
      createRichTextBlock([
        createSegment("g.p3.t.43", "w700 red"),
        createSegment("g.p3.t.44"),
      ]),
      createRichTextBlock([
        createSegment("g.p3.t.45", "w700 red"),
        createSegment("g.p3.t.46"),
      ]),
      createRichTextBlock([
        createSegment("g.p3.t.47", "w700 red"),
        createSegment("g.p3.t.48"),
      ]),
      createRichTextBlock([createSegment("g.p3.t.49")], "w700 step"),
      createRichTextBlock([
        createSegment("g.p3.t.50"),
        createSegment("g.p3.t.51", "w700"),
        createSegment("g.p3.t.52"),
      ]),
      createImageBlock("docImg78"),
      createImageBlock("docImg79"),
      createVideoBlock("docImg79", () => require("@/assets/video/10434_1758004197.mp4")),
    ],
  },
  {
    id: "part_child_3_4",
    titleKey: "guide.home.part.3.4",
    visibleKey: "isShow3_4",
    leadingBreaks: 1,
    trailingBreaks: 1,
    blocks: [
      createRichTextBlock([
        createSegment("g.p3.t.53"),
        createSegment("g.p3.t.54", "w700"),
        createSegment("g.p3.t.55"),
      ]),
      createRichTextBlock([
        createSegment("g.p3.t.56"),
        createSegment("g.p3.t.57", "w700"),
        createSegment("g.p3.t.58"),
      ]),
      createImageBlock("docImg80"),
    ],
  },
  {
    id: "part_child_3_5",
    titleKey: "guide.home.part.3.5",
    visibleKey: "isShow3_5",
    leadingBreaks: 1,
    trailingBreaks: 1,
    blocks: [
      createRichTextBlock([
        createSegment("g.p3.t.59", "w700"),
        createSegment("g.p3.t.60"),
      ]),
      createImageBlock("docImg81"),
      createImageBlock("docImg82"),
      createRichTextBlock([
        createSegment("g.p3.t.61", "w700"),
        createSegment("g.p3.t.62"),
        createSegment("g.p3.t.63", "w700"),
        createSegment("g.p3.t.64"),
      ]),
      createImageBlock("docImg83"),
      createImageBlock("docImg84"),
      createRichTextBlock([
        createSegment("g.p3.t.add.new", "w700"),
        createSegment("g.p3.t.add.new.txt.1"),
      ]),
      createImageBlock("customerTag1"),
      createImageBlock("customerTag2"),
      createTextBlock("g.p3.t.add.new.txt.2"),
      createImageBlock("customerTag3"),
      createRichTextBlock([
        createSegment("g.p3.t.65", "w700"),
        createSegment("g.p3.t.66"),
      ]),
      createImageBlock("docImg85"),
      createRichTextBlock([
        createSegment("g.p3.t.67", "w700"),
        createSegment("g.p3.t.68"),
        createSegment("g.p3.t.69", "w700"),
        createSegment("g.p3.t.70"),
      ]),
      createImageBlock("docImg86"),
      createImageBlock("docImg87"),
      createRichTextBlock([
        createSegment("g.p3.t.73", "w700"),
        createSegment("g.p3.t.74"),
      ]),
      createImageBlock("docImg89"),
      createRichTextBlock([
        createSegment("g.p3.t.75", "w700"),
        createSegment("g.p3.t.76"),
      ]),
      createImageBlock("docImg90"),
    ],
  },
  {
    id: "part_child_3_6",
    titleKey: "guide.home.part.3.6",
    visibleKey: "isShow3_6",
    leadingBreaks: 2,
    trailingBreaks: 1,
    blocks: [
      createRichTextBlock([createSegment("g.p3.t.77")], "step"),
      createRichTextBlock([
        createSegment("g.p3.t.78", "w700"),
        createSegment("g.p3.t.79"),
      ]),
      createImageBlock("P3_1"),
      createRichTextBlock([createSegment("g.p3.t.80")], "step"),
      createTextBlock("g.p3.t.81"),
      createTextBlock("g.p3.t.82"),
      createImageBlock("P3_2"),
      createRichTextBlock([createSegment("g.p3.t.83")], "step"),
      createRichTextBlock([
        createSegment("g.p3.t.84"),
        createSegment("g.p3.t.85", "red"),
        createSegment("g.p3.t.86"),
      ]),
      createImageBlock("P3_3"),
      createTextBlock("g.p3.t.87", "w700"),
      createTextBlock("g.p3.t.88"),
      createImageBlock("P3_4"),
      createTextBlock("g.p3.t.89"),
      createImageBlock("P3_5"),
      createTextBlock("g.p3.t.90", "w700"),
      createRichTextBlock([
        createSegment("g.p3.t.91"),
        createSegment("g.p3.t.92", "w700"),
        createSegment("g.p3.t.93"),
        createSegment("g.p3.t.94", "w700"),
        createSegment("g.p3.t.95"),
        createSegment("g.p3.t.96", "w700"),
        createSegment("g.p3.t.97"),
      ]),
      createImageBlock("P3_6"),
      createImageBlock("P3_7"),
      createTextBlock("g.p3.t.98", "w700"),
      createTextBlock("g.p3.t.99"),
      createImageBlock("P3_8"),
      createRichTextBlock([createSegment("g.p3.t.100")], "step"),
      createRichTextBlock([
        createSegment("g.p3.t.101"),
        createSegment("g.p3.t.102", "w700"),
        createSegment("g.p3.t.103"),
        createSegment("g.p3.t.104", "w700"),
        createSegment("g.p3.t.105"),
        createSegment("g.p3.t.106", "w700"),
        createSegment("g.p3.t.107"),
      ]),
      createImageBlock("P3_9"),
      createRichTextBlock([
        createSegment("g.p3.t.108"),
        createSegment("g.p3.t.109", "w700"),
      ]),
      createImageBlock("P3_10"),
      createRichTextBlock([
        createSegment("g.p3.t.110"),
        createSegment("g.p3.t.111", "w700"),
        createSegment("g.p3.t.112"),
      ]),
      createImageBlock("P3_11"),
      createImageBlock("P3_12"),
      createRichTextBlock([
        createSegment("g.p3.t.113"),
        createLiteralSegment("｛｛ "),
        createSegment("g.p3.t.113.customer"),
        createLiteralSegment(" ｝｝ "),
        createSegment("g.p3.t.113.and"),
        createLiteralSegment(" ｛｛ "),
        createSegment("g.p3.t.113.name"),
        createLiteralSegment(" ｝｝ "),
        createSegment("g.p3.t.113.next"),
      ], "w700 red"),
      createRichTextBlock([createSegment("g.p3.t.114")], "step"),
      createTextBlock("g.p3.t.115"),
      createTextBlock("g.p3.t.116"),
      createTextBlock("g.p3.t.117"),
      createTextBlock("g.p3.t.118"),
      createTextBlock("g.p3.t.119"),
      createTextBlock("g.p3.t.120"),
      createTextBlock("g.p3.t.121"),
      createImageBlock("P3_13"),
      createRichTextBlock([createSegment("g.p3.t.122")], "step"),
      createTextBlock("g.p3.t.123"),
      createTextBlock("g.p3.t.124"),
      createImageBlock("P3_14"),
      createTextBlock("group.txt.tips", "red"),
      createTextBlock("group.txt.des"),
      createTextBlock("group.txt.t1", "w700"),
      createTextBlock("group.txt.t1.1"),
      createTextBlock("group.txt.t1.2"),
      createTextBlock("group.txt.t1.3"),
      createTextBlock("group.txt.t1.4"),
      createTextBlock("group.txt.t1.5"),
      createTextBlock("group.txt.t1.6"),
      createTextBlock("group.txt.t1.7"),
      createTextBlock("group.txt.t1.8"),
      createTextBlock("group.txt.t1.9"),
      createTextBlock("group.txt.t1.10"),
      createTextBlock("group.txt.t1.11"),
      createTextBlock("group.txt.t2", "w700"),
      createTextBlock("group.txt.t1.2"),
      createTextBlock("group.txt.t2.1"),
      createTextBlock("group.txt.t2.2"),
      createTextBlock("group.txt.t2.3"),
      createTextBlock("group.txt.t2.4"),
      createTextBlock("group.txt.t2.5"),
      createTextBlock("group.txt.t2.6"),
      createTextBlock("group.txt.t2.7"),
      createTextBlock("group.txt.t2.8"),
      createTextBlock("group.txt.t2.9"),
      createTextBlock("group.txt.t2.10"),
      createTextBlock("group.txt.t3", "w700"),
      createTextBlock("group.txt.t3.1"),
      createTextBlock("group.txt.t3.2"),
      createTextBlock("group.txt.t3.3"),
      createTextBlock("group.txt.t3.4"),
      createTextBlock("group.txt.t3.5"),
      createTextBlock("group.txt.t4", "w700"),
      createTextBlock("group.txt.t4.1"),
      createTextBlock("group.txt.t4.2"),
      createTextBlock("group.txt.t4.3"),
      createTextBlock("group.txt.t4.4"),
      createTextBlock("group.txt.t4.5"),
      createTextBlock("group.txt.t4.6"),
      createTextBlock("group.txt.t4.7"),
      createTextBlock("group.txt.t5", "w700"),
      createTextBlock("group.txt.t5.1"),
      createTextBlock("group.txt.t5.2"),
      createTextBlock("group.txt.t5.3"),
      createTextBlock("group.txt.t5.4"),
    ],
  },
])

export const homeGuideFaqBlocks = Object.freeze([
  createRichTextBlock([createSegment("g.p5.t.1")], "w700 step"),
  createTextBlock("g.p5.t.2"),
  createImageBlock("docImg123"),
  createRichTextBlock([createSegment("g.p5.t.3")], "w700 step"),
  createTextBlock("g.p5.t.4"),
  createRichTextBlock([createSegment("g.p5.t.5")], "w700 step"),
  createTextBlock("g.p5.t.6"),
  createRichTextBlock([createSegment("g.p5.t.7")], "w700 step"),
  createTextBlock("g.p5.t.8"),
  createRichTextBlock([createSegment("g.p5.t.9")], "w700 step"),
  createTextBlock("g.p5.t.10"),
  createImageBlock("docImg124"),
  createRichTextBlock([createSegment("g.p5.t.11")], "w700 step"),
  createTextBlock("g.p5.t.12"),
  createRichTextBlock([createSegment("g.p5.t.13")], "w700 step"),
  createTextBlock("g.p5.t.14"),
  createRichTextBlock([createSegment("g.p5.t.15")], "w700 step"),
  createTextBlock("g.p5.t.16"),
  createRichTextBlock([createSegment("g.p5.t.17")], "w700 step"),
  createTextBlock("g.p5.t.18"),
  createRichTextBlock([createSegment("g.p5.t.19")], "w700 step"),
  createRichTextBlock([
    createSegment("g.p5.t.20"),
    createSegment("g.p5.t.21", "w700"),
    createSegment("g.p5.t.22"),
    createSegment("g.p5.t.23"),
    createSegment("g.p5.t.24", "w700"),
    createSegment("g.p5.t.25"),
  ]),
  createTextBlock("g.p5.t.27", "w700"),
])
